import { useState } from "react";
import { ReactComponent as SendIcon } from "../../icons/SendIcon.svg";
// import { ReactComponent as AttachIcon } from "../../icons/AttachIcon.svg";
import { CommunitySchema } from "../../data/types";
import { useSendMessage, useLoadMessages, useChatbotTyping, useStaffChatAcknowledgment } from "../../hooks/apphooks";
import { useCompleteSignIn } from "../../hooks/authhooks";
import ChatMessageList from "../../components/ChatMessageList";

interface ChatWindowProps {
  selectedCommunity?: CommunitySchema;
  currentChatCommunity: string;
  username: string;
}

const ChatWindow = ({ selectedCommunity, currentChatCommunity, username }: ChatWindowProps) => {
  const [currentText, updateCurrentText] = useState("");
  const [staffSubmitToken, setStaffSubmitToken] = useState(0);

  const { user } = useCompleteSignIn();
  const loggedinUid = user && user?.uid ? user.uid : "";
  const communityId = selectedCommunity?.id || currentChatCommunity;
  const { messages, isLoadingMessages, isFetchingMessages } = useLoadMessages(
    loggedinUid,
    communityId
  );
  const { sendMessage, isLoadingMessage, pendingMessage } = useSendMessage(loggedinUid, communityId);
  const isMessagesLoading = isLoadingMessages || (isFetchingMessages && !messages);
  const isChatbotTyping = useChatbotTyping(currentChatCommunity, isLoadingMessage);
  const { isStaffTyping, staffAutoReply } = useStaffChatAcknowledgment(
    currentChatCommunity,
    staffSubmitToken,
    messages,
    selectedCommunity?.timezone
  );

  const userLabel =
    user?.first_name || user?.username || username || "You";
  const userAvatar = user?.avatar;

  const handleSubmit = async () => {
    if (communityId && currentText.trim()) {
      await sendMessage(currentText);
      updateCurrentText("");
      if (currentChatCommunity === "staff") {
        setStaffSubmitToken((token) => token + 1);
      }
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      if (currentText.trim()) {
        handleSubmit();
      }
    }
  };

  return (
    <div className="flex flex-col w-full bg-white rounded-b-[16px] font-open-sans min-h-[320px]">
      <div className="flex-1 overflow-y-auto bg-[#FAFAFA] px-3 py-4 min-h-[220px] max-h-[320px]">
        <ChatMessageList
          messages={messages}
          isLoading={isMessagesLoading}
          currentChatCommunity={currentChatCommunity}
          selectedCommunity={selectedCommunity}
          userAvatar={userAvatar}
          userLabel={userLabel}
          variant="desktop"
          isChatbotTyping={isChatbotTyping}
          isStaffTyping={isStaffTyping}
          staffAutoReply={staffAutoReply}
          pendingMessage={pendingMessage}
        />
      </div>

      <hr className="border-[#E9E9E9]" />

      <div className="flex flex-row items-center gap-2 w-full px-3 py-3 bg-white">
        {/* <button
          type="button"
          className="flex-shrink-0 w-10 h-10 p-0 flex items-center justify-center bg-white border border-[#E9E9E9] hover:border-primaryDark-300 rounded-full transition-colors cursor-pointer"
          aria-label="Attach file"
        >
          <AttachIcon className="w-5 h-5 text-gray-600" />
        </button> */}

        <textarea
          onChange={(e) => updateCurrentText(e.target.value)}
          onKeyPress={handleKeyPress}
          value={currentText}
          rows={1}
          className="flex-1 min-h-[44px] max-h-24 px-3 py-2.5 text-sm border border-[#E9E9E9] rounded-lg bg-white text-gray-800 resize-none font-open-sans placeholder:text-gray-400 focus:outline-none focus:ring-1 focus:ring-primaryDark-300 focus:border-transparent"
          placeholder="Type a message"
        />

        <button
          type="button"
          onClick={handleSubmit}
          disabled={!currentText.trim()}
          className="flex-shrink-0 w-10 h-10 p-0 flex items-center justify-center bg-primaryDark-0 hover:bg-primaryDark-200 disabled:bg-gray-300 disabled:cursor-not-allowed rounded-full transition-colors cursor-pointer border-0"
          aria-label="Send message"
        >
          <SendIcon className="w-5 h-5 text-white" />
        </button>
      </div>
    </div>
  );
};

export default ChatWindow;
